<script lang="ts">
  import { router, link, href } from '../router.svelte';

  const tabs = [
    { path: '/ask', label: 'Ask', icon: 'M4 5h16M4 12h10M4 19h7' },
    { path: '/read', label: 'Read', icon: 'M4 5h16v14H4zM9 5v14' },
    { path: '/capture', label: 'Capture', icon: 'M12 5v14M5 12h14' },
    { path: '/settings', label: 'Settings', icon: 'M6 6h12v12H6zM10 3h4v3h-4zM10 18h4v3h-4z' },
  ];

  const active = $derived(router.current.path);
</script>

<nav class="tabbar">
  {#each tabs as t (t.path)}
    <a
      href={href(t.path)}
      use:link
      class="tab"
      class:on={active === t.path}
      aria-current={active === t.path ? 'page' : undefined}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6">
        <path d={t.icon} stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>{t.label}</span>
    </a>
  {/each}
</nav>

<style>
  .tabbar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 50;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    background: var(--cream-2);
    border-top: 1px solid var(--line);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    padding: 8px 0 6px;
    color: var(--ink-faint);
    font-family: var(--mono);
    font-size: 10px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    transition: color 0.15s;
  }
  .tab.on {
    color: var(--rooster);
  }
  @media (min-width: 900px) {
    .tabbar {
      top: 0;
      right: auto;
      bottom: 0;
      width: 84px;
      grid-template-columns: 1fr;
      grid-auto-rows: max-content;
      align-content: start;
      gap: 4px;
      padding-top: 20px;
      border-top: none;
      border-right: 1px solid var(--line);
    }
  }
</style>
